module.exports = __webpack_public_path__ + "27fd2a482dd9b87983cadcd09a25ab94.png";